import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { SectionHeader, FadeUp } from "../components/primitives";
import { LeadForm } from "../components/LeadForm";
import { useLang } from "../i18n";

const Contact = () => {
  const { t } = useLang();
  const paths = [
    { title: t.contact.brandPath, body: t.contact.brandPathBody, cta: t.cta.talk, to: "/for-brands", grad: true },
    { title: t.contact.pubPath, body: t.contact.pubPathBody, cta: t.cta.join, to: "/for-publishers", grad: false },
  ];
  return (
    <div className="overflow-hidden">
      <PageHero over={t.contact.heroOver} title={t.contact.heroTitle} />

      <section className="py-16 md:py-20 bg-white">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10 grid lg:grid-cols-2 gap-8">
          {paths.map((p, i) => (
            <FadeUp key={i} delay={i * 0.1}>
              <Link to={p.to} data-testid={`contact-path-${i}`}
                className={`group relative block rounded-3xl p-10 md:p-14 min-h-[280px] flex flex-col justify-between overflow-hidden transition-all duration-500 hover:scale-[1.01] ${p.grad ? "wanm-gradient-bg text-white grain" : "bg-wanm-dark text-white"}`}>
                <h3 className="text-3xl md:text-4xl font-black tracking-tight relative z-10">{p.title}</h3>
                <div className="relative z-10">
                  <p className="text-lg text-white/80 max-w-sm">{p.body}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-bold text-lg group-hover:gap-3 transition-all">{p.cta} <ArrowUpRight size={22} /></span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="py-20 md:py-28 bg-wanm-offwhite">
        <div className="mx-auto max-w-4xl px-5 md:px-10">
          <SectionHeader over={t.contact.formOver} title={t.contact.formTitle} align="center" />
          <div className="mt-14 bg-white rounded-3xl p-8 md:p-12">
            <LeadForm endpoint="/leads/contact" testId="contact-form" submitLabel={t.form.submit}
              fields={[
                { id: "name", required: true }, { id: "email", type: "email", required: true },
                { id: "company" }, { id: "message", textarea: true, required: true },
              ]} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
